import { API } from "aws-amplify";
import Auth from "@aws-amplify/auth";
import { store } from "../../store";

const getHeaders = async () => {
  const user = await Auth.currentAuthenticatedUser();
  const jwtToken = user.signInUserSession?.accessToken?.jwtToken;
  const headers = {};
  if (jwtToken) headers['Authorization'] = 'Bearer ' + jwtToken;
  const { loginReducer } = store.getState();
  const clientId = loginReducer?.groups?.[0];
  if (clientId) headers['BluStream-Client-ID'] = clientId;
  return headers;
};

const customerUuid = () => {
  const { loginReducer } = store.getState();
  return loginReducer?.groups?.[0];
};

// GET /api/demo/status?customerUuid=...
export const getDemoStatus = async () => {
  const uuid = customerUuid();
  const headers = await getHeaders();
  return API.get("blustreamREST", `/gandalfproxy/api/demo/status?customerUuid=${uuid}`, { headers });
};

// POST /api/demo/reset?customerUuid=...
export const resetDemoSandbox = async () => {
  const uuid = customerUuid();
  const headers = await getHeaders();
  return API.post("blustreamREST", `/gandalfproxy/api/demo/reset?customerUuid=${uuid}`, { headers, body: {} });
};

// GET /api/demo/store-config?customerUuid=...
export const getStoreConfig = async () => {
  const uuid = customerUuid();
  const headers = await getHeaders();
  return API.get("blustreamREST", `/gandalfproxy/api/demo/store-config?customerUuid=${uuid}`, { headers });
};

// GET /api/demo/webchat-link?customerUuid=...
export const getWebchatLink = async () => {
  const uuid = customerUuid();
  const headers = await getHeaders();
  return API.get("blustreamREST", `/gandalfproxy/api/demo/webchat-link?customerUuid=${uuid}`, { headers });
};
